import SecureLS from "secure-ls"
var ls = new SecureLS({encodingType: 'aes'});
export default ()=>{
    return localStorage
    return {
        setItem:(key,value) =>{
            ls.set(key,value)
        },
        getItem:(key) =>{
            return ls.get(key)
        },
        clear:() =>{
            ls.clear()
        }
    }
}